module.exports = __webpack_public_path__ + "static/img/y-2.d2edf9da.png";